import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './About.css';

import imgLeft from './../../assets/home-pic_1.jpg';
import imgRight from './../../assets/certificate.jpg';

const About = () => {
    return (
        <div className="container my-3">

            <div className="abouts">
                <h5>About Us</h5>
            </div>

            <div className="about-box p-4 rounded shadow-lg" style={{textAlign:'justify'}}>

                <div className="row mb-1 justify-content-between">
                    {/* First Paragraph */}
                    <div className="col-lg-12">
                        <p className="">
                            The Haryana Seeds Development Corporation Limited was established in the year 1974 under the Companies Act, 1956 with the objective of organizing the production and distribution of certified seeds to the farmers of the State at reasonable rates.
                        </p>
                    </div>

                    {/* Second Row with Image and Paragraph */}
                    <div className="col-lg-6">
                        <p className="">
                            The Authorized Share Capital of the Corporation is Rs. 7.00 crore. The Share Capital is contributed by the State Government, National Seeds Corporation Limited and Shareholder Seed Growers of the Corporation.
                        </p>
                    </div>
                    <div className="col-lg-6 ps-5">
                        <img src={imgLeft} alt="Seed Production" className="img-fluid rounded shadow-sm" />
                    </div>

                    {/* Third Paragraph */}
                    <div className="col-lg-12">
                        <p className="section-text">
                            The Corporation has the distinction to have senior Civil Servants as its Chairman and Managing Director. Civil Servants from the Indian Administrative Service have acted as Chairman/Managing Director and guided the Corporation since its inception to reach its glorious present. Their rich and vast experience has brought about significant improvement in the working and development of the Corporation. Similarly, the Corporation has also the privilege to have senior Civil Servants leading public men and senior officers of the Central Government as Directors on its Board who have contributed their best in formulating policies of the Corporation.
                        </p>
                    </div>
                </div>

                <div className="row  justify-content-between mb-5">
                    <div className="col-lg-12 ">

                        <p className="section-text">
                            <strong>
                                We corporation also received the second & Best Productivity Performance Award from National Productivity Council of India in the year, 2004.
                            </strong>
                        </p>
                        </div>
                        <div className="col-lg-6 ">
                        <p className="section-text">
                            Haryana Seeds Development Corporation Limited has established 6 Seed Processing Plants at Umri, Hisar, Sirsa, Yamuna Nagar, Tohana and Pataudi and one Marketing Center at Bhiwani. It has also established a Cotton Ginning and Bale Pressing cum Acid Delinting Factory at Hisar in order to maintain purity of cotton seed. Marketing of Certified Seeds is done through its own network of 74 Sale Counters, Institutional Agencies like HAFED, HAIC, Mini Banks, etc.
                        </p>
                        </div>
                        <div className="col-lg-6 mb-4 ps-5 pt-3 ">
                        <img src={imgRight} alt="Seed Processing" className="img-fluid rounded shadow-sm" />
                    </div>
                        <div className="col-lg-12 ">
                        <p className="section-text">
                            The Corporation is maintaining a Seed Testing Lab at Umri for testing seed samples as an internal quality control measure. Its technically qualified staff exercises strict quality controls right from the field stage, processing, and during storage so that only good quality seeds are supplied to the farmers.
                        </p>
                    </div>
                    
                    </div>
                </div>
            </div>
       
    );
};

export default About;
